import { useShowContext } from 'framework/show';
import { useEmployeeDashboardActions } from './useDashboardActions';
import { useCoordinatorManagement } from './useCoordinatorManagement';
import { useZoneManagement } from './useZoneManagement';
import { DashboardEmployee } from '../types';
import { DashboardMenuOption } from 'domain/shared/core/dashboard';
import { DELEGATED_EMPLOYEE_ZONES_ALIASES, EMPLOYEE_ZONES } from '../constants';
import OpenWithRounded from '@mui/icons-material/OpenWithRounded';
import PersonRounded from '@mui/icons-material/PersonRounded';
import WarningRounded from '@mui/icons-material/WarningRounded';
import NotificationsRounded from '@mui/icons-material/NotificationsRounded';
import HealthAndSafetyRounded from '@mui/icons-material/HealthAndSafetyRounded';
import { isPolishContractorByEmployeeType } from 'domain/shared/employee';

export const useMenuOptions = () => {
  const { data } = useShowContext<DashboardEmployee>();
  const { handleManageIssues, handleAddFollowUp, handleConductHealthcheck } = useEmployeeDashboardActions();
  const { coordinatorOptions } = useCoordinatorManagement();
  const { zoneOptions } = useZoneManagement();

  const employeeData = data.getData();
  const currentZone = (data as any).currentZone || employeeData.retentionRiskPriority;
  const isDelegatedZone = currentZone === DELEGATED_EMPLOYEE_ZONES_ALIASES.DELEGATED;
  const isPolishContractor = isPolishContractorByEmployeeType(employeeData);

  const allMenuOptions = [
    {
      key: DashboardMenuOption.MANAGE_ISSUES,
      label: 'Issues',
      onClick: () => handleManageIssues(employeeData),
      icon: <WarningRounded fontSize="small" />,
    },
    {
      key: DashboardMenuOption.ADD_FOLLOW_UP,
      label: 'Follow-up',
      onClick: () => handleAddFollowUp(),
      icon: <NotificationsRounded fontSize="small" />,
    },
    {
      key: DashboardMenuOption.CONDUCT_HEALTHCHECK,
      label: 'Healthcheck',
      onClick: () => handleConductHealthcheck(),
      icon: <HealthAndSafetyRounded fontSize="small" />,
    },
    {
      key: DashboardMenuOption.CHANGE_STAFFING_COORDINATOR,
      label: 'Manager',
      expandable: true,
      subOptions: coordinatorOptions,
      icon: <PersonRounded fontSize="small" />,
    },
    {
      key: DashboardMenuOption.CHANGE_ZONE,
      label: EMPLOYEE_ZONES[currentZone as keyof typeof EMPLOYEE_ZONES],
      expandable: true,
      subOptions: zoneOptions,
      icon: <OpenWithRounded fontSize="small" />,
    },
  ];

  const menuOptions = allMenuOptions.filter(
    option =>
      !(isDelegatedZone && option.key === DashboardMenuOption.CHANGE_ZONE) &&
      !(isPolishContractor && option.key === DashboardMenuOption.CONDUCT_HEALTHCHECK),
  );

  return {
    menuOptions,
  };
};
